import styled from 'styled-components';
import { Colors } from 'basic-ui-lib/constants';
import { Text } from 'basic-ui-lib/components/Text';
import { IcChevronDown } from 'basic-ui-lib/icons';
import { Col } from 'basic-ui-lib';
import { useEffect, useMemo, useState } from 'react';
import StorePickerModal from './StorePickerModal';
import useGetListStores from 'modules/store/services/hooks/useGetListStore';

interface StorePickerMobileProps {
  value?: string;
  onChange?: (storeId: string) => void;
}

const StorePickerMobile = ({ value, onChange }: StorePickerMobileProps) => {
  const { storesList: storesData, mutate: fetchStores } = useGetListStores(true);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    fetchStores({ page: 1, size: 50 });
  }, []);

  const storeOptions = useMemo(() => {
    const stores = storesData?.content ?? [];
    return stores.map((store) => ({
      label: store.storeName,
      value: store.storeId,
    }));
  }, [storesData]);
  const storeName = storeOptions.find((store) => store.value === value)?.label;
  return (
    <>
      <SelectorButton onClick={() => setOpen(true)} type='button'>
        <Col gap={0}>
          <Text caption_4 regular left>
            Store
          </Text>
          <TextWrapper>
            <Text caption_3 medium color='neutral.text.5' left ellipsis lineClamp={1}>
              {storeName || 'Select Store'}
            </Text>
          </TextWrapper>
        </Col>
        <IcChevronDown fill={Colors.primary[5]} width={16} height={16} />
      </SelectorButton>

      <StorePickerModal
        value={value}
        onChange={onChange}
        listStores={storeOptions}
        open={open}
        onClose={() => setOpen(false)}
      />
    </>
  );
};

export default StorePickerMobile;

const SelectorButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  height: 49px;
  width: 100%;
  background: ${Colors.neutral.bg[1]};
  border: 1px solid ${Colors.neutral.border[1]};
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;

  &:hover {
    border-color: ${Colors.primary[5]};
  }

  &:focus {
    border-color: ${Colors.primary[5]};
    outline: none;
  }
`;

const TextWrapper = styled.div`
  flex: 1;
  min-width: 0;
  text-align: left;

  .custom-text {
    max-width: 60px;
  }
`;
